import axios from 'axios';
import { devToken } from '../config/config';
import { MD5 } from 'crypto-js'
import { getCookie } from '@/utils/cookie';
import { Message } from 'element-ui';
import { getToken } from '../context/authorization'

// 创建 axios 实例
const service = axios.create({
    //baseURL: window.global_apiConfig.baseApiUrl, // 替换为实际的 API 基础地址
    timeout: 5000 // 请求超时时间
});


// const sissCloudTokenID = getCookie('SissCloudTokenID');


// 请求拦截器
// service.interceptors.request.use(
//     config => {
//         // 在发送请求之前做些什么，例如添加请求头
//         // config.headers['Authorization'] = 'Bearer ' + token;

//         config.headers['content-type']= 'application/json';
//         return config;
//     },
//     error => {
//         // 处理请求错误
//         console.error('请求出错:', error);
//         return Promise.reject(error);
//     }
// );

// 响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        return response.data;
    },
    error => {
        console.log('err' + error); // for debug
        if (error.message === 'Network Error') {
            Message.error('网络连接失败，请检查网络设置后重试。');
        } else if (error.code === 'ECONNABORTED') {
            Message.error('请求超时，请稍后重试。');
        } else {
            Message.error(`请求出错：${error.message}`);
        }
        return Promise.reject(error);
    }
);

const createHeader = async (data) => {
    let temp = Date.parse(new Date()) / 1000;
    let header = {}
    let token= await getToken()
    header.apptoken = token||devToken
    header.sisscloudtokenid = sessionStorage.getItem('SessionTokenId')||getCookie('SissCloudTokenID')
    header.timestamp = temp.toString()
    header.noncestr = Math.random().toString().substring(2)
    header.tdEnv = 'latest'

    let params = {
        apptoken: token||devToken,
        sisscloudtokenid: header.sisscloudtokenid,
        appkey: window.global_apiConfig.appKey,
        noncestr: header.noncestr,
        timestamp: header.timestamp
    };
    params = Object.assign(params, data)
    header.sign = paramsSign(params)
    return header;
};

export const paramsSign = (params) => {
    let ss = []
    const keys = Object.keys(params).sort()

    for (const i in keys) {
        const value = params[keys[i]]
        if (value == undefined) {
            continue
        } else if (value.constructor == Array || value.constructor == Object) {
            ss.push(keys[i] + '=' + JSON.stringify(params[keys[i]]))
        }

        else if (value != undefined && value.toString().trim() != '') {
            // Number、Boolean、String
            ss.push(keys[i] + '=' + params[keys[i]])
        }
    }
    ss = ss.join('&')

    const signStr = MD5(ss).toString().toUpperCase()
    return signStr
};

export const get = async (url, params, isgetSessiom) => {
    let header = await createHeader(params);
    return new Promise((resolve, reject) => {
        axios
            .get(isgetSessiom ? url : window.global_apiConfig.baseApiUrl + url, {
                params: params,
                headers: header
            })
            .then( async (res) => {
                if (res.data.Code === 103 || res.data.ErrorCode === 103) {
                    //登录页面
                    window.location.href = '/login-form';
                    //this.$router.replace('/login-form');

                } else if (res.Code === 106 || res.ErrorCode === 106) {
                    //登录页面
                    window.location.href = '/login-form';
                    //this.$router.replace('/login-form');

                } else {
                    resolve(res.data);
                }
                //resolve(res.data);
            })
            .catch((err) => {
                reject(err)
            })
    })
};

export const post = async (url, data, isgetSessiom) => {

    let header = await createHeader(data);
    // header.Authorization='Bearer S2V5OjhERjFBQjE2MkMwQTYwMjQ0OUQxMzNCN0JGMDlDRDY1LFRlbmFudElkOjQzMzEyMw=='
    console.log('header', header);
    return new Promise((resolve, reject) => {
        axios
            .post(isgetSessiom ? url : window.global_apiConfig.baseApiUrl + url, data, { headers: header })
            .then( async (res) => {
                console.log('res', res);
                if (res.data.Code === 103 || res.data.ErrorCode === 103) {
                    window.location.href = '/login-form';
                    //this.$router.replace('/login-form');

                } else if (res.Code === 106 || res.ErrorCode === 106) {
                    //登录页面
                    window.location.href = '/login-form';
                    //this.$router.replace('/login-form');

                } else {
                    resolve(res.data);
                }

            })
            .catch((err) => {
                console.log('err', err);
                reject(err);
            });
    });
};

export default service;
